import { Injectable } from '@angular/core';
import { AppService } from '../../../../../core/service/Base.Service';

@Injectable()
export class TemplateService extends AppService<any> {

    constructor() {
        super('Smstemplate');

    }

    async GetTemplates() {
        const result = await this.get('');
        return result;
    }

    async GetTemplate(templatetypeid) {
        const result = await this.get('Template', [templatetypeid]);
        return result;
    }

    async TemplateData() {
        const result = await this.get('TemplateData');
        return result;
    }

}


// WEBPACK FOOTER //
// ./src/app/shell/forms/organizational-setup/setup/template/template.service.ts